<div class='finance-cost-tab1-part'>
	This is finance-cost tab 1
</div>